'use client';

import { __assign } from '../_virtual/_tslib.js';
import React__default, { useState, useEffect } from 'react';
import { TranslateContext } from '../Contexts/translator/index.js';
import translations from './translations.js';
import { ELanguage } from '../Utils/constants.js';
import { OnBoardingContext } from './context/index.js';
import { EStep } from './type.js';
import { getOptions } from './helper.js';
import { initFormData } from './const.js';
import { Container, BodyContainer } from './styles.css.js';
import { Header } from './components/Layout/Header.js';
import '../LayoutSystem/Col.js';
import Row from '../LayoutSystem/Row.js';
import { Footer } from './components/Layout/Footer.js';
import { createPortal } from 'react-dom';
import useHash from '../Utils/hooks/UseHash/index.js';
import Welcome from './components/Welcome/index.js';
import { ContactInfo } from './components/ContactInfo/index.js';
import ChooseResume from './components/ChooseResume/index.js';
import UploadAttachResume from './components/UploadAttachResume/index.js';
import BasicInfo from './components/BasicInfo/index.js';
import Skills from './components/Skill/index.js';
import Successfully from './components/Successfully/index.js';
import { translator } from '../Contexts/translator/helper.js';

var OnBoarding = function (_a) {
    var _b, _c, _d, _e;
    var isShow = _a.isShow, _f = _a.lang, lang = _f === void 0 ? ELanguage.VI : _f, accessToken = _a.accessToken, baseMsUrl = _a.baseMsUrl, baseUrl = _a.baseUrl, baseImageUrl = _a.baseImageUrl, jobLevels = _a.jobLevels, countries = _a.countries, cities = _a.cities, districts = _a.districts, categories = _a.categories, industries = _a.industries, user = _a.user;
    var _g = useHash(), hash = _g[0], setHash = _g[1];
    // const [step, setStep] = useState<EStep>(EStep.Welcome)
    var _h = useState('attachCV'), resumeType = _h[0], setResumeType = _h[1];
    var _j = useState(__assign(__assign({}, initFormData), { firstName: (_b = user.firstName) !== null && _b !== void 0 ? _b : '', lastName: (_c = user.lastName) !== null && _c !== void 0 ? _c : '', email: (_d = user.userName) !== null && _d !== void 0 ? _d : '', phone: (_e = user.phone) !== null && _e !== void 0 ? _e : '' })), formResumeInfo = _j[0], setFormResumeInfo = _j[1];
    var _k = useState(), fileInfo = _k[0], setFileInfo = _k[1];
    var _l = useState(false), isLoading = _l[0], setIsLoading = _l[1];
    var t = function (txt) {
        var text = translator(txt, translations, lang);
        return text;
    };
    var contextValue = {
        lang: lang,
        hash: hash,
        setHash: setHash,
        accessToken: accessToken,
        baseMsUrl: baseMsUrl,
        baseUrl: baseUrl,
        baseImageUrl: baseImageUrl,
        jobLevels: getOptions(jobLevels, lang),
        countries: getOptions(countries, lang),
        cities: getOptions(cities, lang),
        districts: districts,
        categories: getOptions(categories, lang),
        industries: industries,
        user: user,
        resumeType: resumeType,
        setResumeType: setResumeType,
        fileInfo: fileInfo,
        setFileInfo: setFileInfo,
        formResumeInfo: formResumeInfo,
        setFormResumeInfo: setFormResumeInfo,
        isLoading: isLoading,
        setIsLoading: setIsLoading
    };
    var renderStep = function () {
        var hashValue = hash.split('#').pop();
        switch (hashValue) {
            case EStep.Welcome:
                return React__default.createElement(Welcome, null);
            case EStep.PersonalInformatoion:
                return React__default.createElement(ContactInfo, null);
            case EStep.HaveCV:
                return React__default.createElement(ChooseResume, null);
            case EStep.UploadCV:
                return React__default.createElement(UploadAttachResume, null);
            case EStep.BasicInformation:
                return React__default.createElement(BasicInfo, null);
            case EStep.Skill:
                return React__default.createElement(Skills, null);
            case EStep.Recommendation:
                return React__default.createElement(Welcome, null);
            case EStep.Successfully:
                return React__default.createElement(Successfully, null);
        }
    };
    var renderFooter = function () {
        var hashValue = hash === null || hash === void 0 ? void 0 : hash.split('#').pop();
        var isHideFooter = hashValue === EStep.Welcome || hashValue === EStep.Successfully;
        if (isHideFooter)
            return;
        return React__default.createElement(Footer, { onBack: function () { }, onContinue: function () { } });
    };
    var bodyNode = typeof document !== 'undefined' ? document === null || document === void 0 ? void 0 : document.querySelector('body') : null;
    useEffect(function () {
        if (!bodyNode) {
            return;
        }
        document.body.style.overflow = 'initial';
        setHash(EStep.BasicInformation);
        if (isShow) {
            document.body.style.overflow = 'hidden';
        }
        return function () {
            document.body.style.overflow = 'initial';
        };
    }, [bodyNode, isShow]);
    if (!bodyNode)
        return React__default.createElement(React__default.Fragment, null);
    return isShow ? (createPortal(React__default.createElement(OnBoardingContext.Provider, { value: contextValue },
        React__default.createElement(TranslateContext.Provider, { value: { t: t } },
            React__default.createElement(Container, null,
                React__default.createElement(Header, null),
                React__default.createElement(BodyContainer, null,
                    React__default.createElement(Row, { gutter: 16, container: { sm: 12 } }, renderStep())),
                renderFooter()))), bodyNode)) : (React__default.createElement(React__default.Fragment, null));
};

export { OnBoarding, OnBoarding as default };
//# sourceMappingURL= index.js.map
